import { fetchProgramData, fetchTranslationData, loginToExpress } from '../api-requests';
import { DEFAULT_OPTIONS } from './constants';
const DATA_GLOBAL_STATE = 'data-states';
const dataStatesFn = (statechart) => {
    statechart.addState('#signin', {
        globalConcurrentState: DATA_GLOBAL_STATE,
        setInitialConfiguration: (options) => {
            const thisState = statechart.getState('#signin', DATA_GLOBAL_STATE);
            const mergedOptions = {
                ...DEFAULT_OPTIONS,
                ...options
            };
            thisState.setData('options', mergedOptions);
            if (mergedOptions?.medalliaConfig?.url) {
                statechart.sendEvent('fetch_translations', options.locale);
                return;
            }
            if (mergedOptions.skipLogin) {
                thisState.goToState('#logged-in', { options: mergedOptions });
            }
        },
        successfulLogin: () => {
            const thisState = statechart.getState('#signin', DATA_GLOBAL_STATE);
            const options = thisState.getData('options');
            thisState.goToState('#logged-in', { options });
        }
    });
    statechart.addState('#signin.ready', {
        globalConcurrentState: DATA_GLOBAL_STATE,
        parentState: '#signin',
        fetch_translations: (locale) => {
            const thisState = statechart.getState('#signin.ready', DATA_GLOBAL_STATE);
            const options = thisState.getData('options');
            const translationPromise = fetchTranslationData({
                ...options,
                locale
            });
            translationPromise
                .then(({ translationsData, translationsError }) => {
                if (translationsError) {
                    statechart.sendEvent('serverError', translationsError);
                    return;
                }
                statechart.sendEvent('updateTranslations', translationsData);
            })
                .catch((err) => {
                statechart.sendEvent('serverError', err);
            });
        },
        process_login: async (username, password) => {
            const thisState = statechart.getState('#signin.ready', DATA_GLOBAL_STATE);
            const options = thisState.getData('options');
            try {
                const { error: { message: loginErrorMessage } = {} } = await loginToExpress({
                    options,
                    username,
                    password
                });
                if (loginErrorMessage) {
                    statechart.sendEvent('serverError', loginErrorMessage);
                    return;
                }
                statechart.sendEvent('successfulLogin');
            }
            catch (err) {
                statechart.sendEvent('serverError', err);
            }
        }
    });
    statechart.addState('#logged-in', {
        globalConcurrentState: DATA_GLOBAL_STATE,
        substatesAreConcurrent: true,
        logout: () => {
            const thisState = statechart.getState('#logged-in', DATA_GLOBAL_STATE);
            thisState.goToState('#signin.ready');
        }
    });
    statechart.addState('#logged-in.projects', {
        globalConcurrentState: DATA_GLOBAL_STATE,
        parentState: '#logged-in',
        refreshPrograms: async () => {
            const thisState = statechart.getState('#logged-in.projects', DATA_GLOBAL_STATE);
            const options = thisState.getData('options');
            try {
                const { data, error: { message: programDataError = '' } = {}, status } = await fetchProgramData(options);
                if (programDataError.length > 0) {
                    statechart.sendEvent('serverError', programDataError);
                    return;
                }
                if (status === 401) {
                    statechart.sendEvent('logout');
                    return;
                }
                statechart.sendEvent('updateProgramData', data);
            }
            catch (err) {
                statechart.sendEvent('serverError', err);
            }
        }
    });
};
export default dataStatesFn;
